/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Coil_ElectricInputs */



/**
* | output |
* | --- |
* | "Electric coil" |
*
* @param {Air_Handler_Unit_Coil_ElectricInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_coil_electric = /** @type {((inputs?: Air_Handler_Unit_Coil_ElectricInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Coil_ElectricInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Electric coil")
	return /** @type {LocalizedString} */ ("Batterie Électrique")
});